/*
 * @Description: 公共函数
 */

import { isNull } from "util";
import dateTool from "@/utils/dateTool";

/**
 * //type拿取饼图，柱状图的电费或电量
 * @param {*} resData 接口数据
 * @param {*} type 拿饼图还是柱状图
 */
export const getEcharts = function(resData, type) {
  if (type == "pie") {
    for (let i = 0; i < resData.detail.length; i++) {
      let newDf = [];
      if (resData.detail[i]?.model == 1) {
        newDf.push(resData.detail[i]);
      }
      // }
      let fConsumption = null; //峰电用量
      let pConsumption = null; //平电用量
      let gConsumption = null; //谷电用量
      let jConsumption = null; //尖电用量
      let fFree = null; //峰电费用
      let pFree = null; //平电费用
      let gFree = null; //峰电费用
      let jFree = null; //峰电费用
      let eleUser = null; //累计电量
      let eleFree = null; //累计电费用
      for (let i = 0; i < newDf.length; i++) {
        if (newDf[i].values.length > 0) {
          if (!isNaN(newDf[i].values[0].energyUsed) && !fConsumption) {
            fConsumption = newDf[i].values[0].energyUsed;
          } else {
            fConsumption += newDf[i].values[0].energyUsed;
          }
          if (!isNaN(newDf[i].values[1].energyUsed) && !pConsumption) {
            pConsumption = newDf[i].values[1].energyUsed;
          } else {
            pConsumption += newDf[i].values[1].energyUsed;
          }
          if (!isNaN(newDf[i].values[2].energyUsed) && !gConsumption) {
            gConsumption = newDf[i].values[2].energyUsed;
          } else {
            gConsumption += newDf[i].values[2].energyUsed;
          }
          if (!isNaN(newDf[i].values[3].energyUsed) && !jConsumption) {
            jConsumption = newDf[i].values[3].energyUsed;
          } else {
            jConsumption += newDf[i].values[3].energyUsed;
          }
          if (!isNaN(newDf[i].values[0].value) && !fFree) {
            fFree = newDf[i].values[0].value;
          } else {
            fFree += newDf[i].values[0].value;
          }
          if (!isNaN(newDf[i].values[1].value) && !pFree) {
            pFree = newDf[i].values[1].value;
          } else {
            pFree += newDf[i].values[1].value;
          }
          if (!isNaN(newDf[i].values[2].value) && !gFree) {
            gFree = newDf[i].values[2].value;
          } else {
            gFree += newDf[i].values[2].value;
          }
          if (!isNaN(newDf[i].values[3].value) && !jFree) {
            jFree = newDf[i].values[3].value;
          } else {
            jFree += newDf[i].values[3].value;
          }
        }
        if (!isNaN(newDf[i].energyUsed) && !eleUser) {
          eleUser = newDf[0].energyUsed;
        } else {
          eleUser += newDf[i].energyUsed;
        }
        if (!isNaN(newDf[i].value) && !eleFree) {
          eleFree = newDf[0].value;
        } else {
          eleFree += newDf[i].value;
        }
      }
      fConsumption = isNull(fConsumption) ? "-" : fConsumption.toFixed(2); //峰电量
      pConsumption = isNull(pConsumption) ? "-" : pConsumption.toFixed(2); //平电量
      gConsumption = isNull(gConsumption) ? "-" : gConsumption.toFixed(2); //谷电量
      jConsumption = isNull(jConsumption) ? "-" : jConsumption.toFixed(2); //尖电量
      fFree = isNull(fFree) ? "-" : fFree.toFixed(2); //峰費用
      pFree = isNull(pFree) ? "-" : pFree.toFixed(2); //平費用
      gFree = isNull(gFree) ? "-" : gFree.toFixed(2); //谷費用
      jFree = isNull(jFree) ? "-" : jFree.toFixed(2); //尖費用
      eleUser = isNull(eleUser) ? "-" : eleUser.toFixed(2); //用量
      eleFree = isNull(eleFree) ? "-" : eleFree.toFixed(2); //費用
      resData.fValue = fConsumption;
      resData.pValue = pConsumption;
      resData.gValue = gConsumption;
      resData.jValue = jConsumption;
      resData.fValue1 = fFree;
      resData.pValue1 = pFree;
      resData.gValue1 = gFree;
      resData.jValue1 = jFree;
      resData.userValue = eleUser;
      resData.eleValue = eleFree;
    }
  } else {
    for (let k = 0; k < resData.length; k++) {
      //拿当前月的用电量
      let newDf = [];
      for (let i = 0; i < resData[k].detail.length; i++) {
        if (resData[k].detail[i].model == 1) {
          newDf.push(resData[k].detail[i]);
        }
      }
      let fConsumption = null; //峰电用量
      let pConsumption = null; //平电用量
      let gConsumption = null; //谷电用量
      let jConsumption = null; //尖电用量
      let fFree = null; //峰电费用
      let pFree = null; //平电费用
      let gFree = null; //峰电费用
      let jFree = null; //尖电费用
      let eleUser = null; //累计电量
      let eleFree = null; //累计电费用
      for (let i = 0; i < newDf.length; i++) {
        if (newDf[i].values.length > 0) {
          if (!isNaN(newDf[i].values[0].energyUsed) && !fConsumption) {
            fConsumption = newDf[i].values[0].energyUsed;
          } else {
            fConsumption += newDf[i].values[0].energyUsed;
          }
          if (!isNaN(newDf[i].values[1].energyUsed) && !pConsumption) {
            pConsumption = newDf[i].values[1].energyUsed;
          } else {
            pConsumption += newDf[i].values[1].energyUsed;
          }
          if (!isNaN(newDf[i].values[2].energyUsed) && !gConsumption) {
            gConsumption = newDf[i].values[2].energyUsed;
          } else {
            gConsumption += newDf[i].values[2].energyUsed;
          }
          if (!isNaN(newDf[i].values[3].energyUsed) && !jConsumption) {
            jConsumption = newDf[i].values[3].energyUsed;
          } else {
            jConsumption += newDf[i].values[3].energyUsed;
          }
          if (!isNaN(newDf[i].values[0].value) && !fFree) {
            fFree = newDf[i].values[0].value;
          } else {
            fFree += newDf[i].values[0].value;
          }
          if (!isNaN(newDf[i].values[1].value) && !pFree) {
            pFree = newDf[i].values[1].value;
          } else {
            pFree += newDf[i].values[1].value;
          }
          if (!isNaN(newDf[i].values[2].value) && !gFree) {
            gFree = newDf[i].values[2].value;
          } else {
            gFree += newDf[i].values[2].value;
          }
          if (!isNaN(newDf[i].values[3].value) && !jFree) {
            jFree = newDf[i].values[3].value;
          } else {
            jFree += newDf[i].values[3].value;
          }
        }
        if (!isNaN(newDf[i].energyUsed) && !eleUser) {
          eleUser = newDf[0].energyUsed;
        } else {
          eleUser += newDf[i].energyUsed;
        }
        if (!isNaN(newDf[i].value) && !eleFree) {
          eleFree = newDf[0].value;
        } else {
          eleFree += newDf[i].value;
        }
      }
      fConsumption = isNull(fConsumption) ? "-" : fConsumption.toFixed(2); //峰电量
      pConsumption = isNull(pConsumption) ? "-" : pConsumption.toFixed(2); //平电量
      gConsumption = isNull(gConsumption) ? "-" : gConsumption.toFixed(2); //谷电量
      jConsumption = isNull(jConsumption) ? "-" : jConsumption.toFixed(2); //尖电量
      fFree = isNull(fFree) ? "-" : fFree.toFixed(2); //峰費用
      pFree = isNull(pFree) ? "-" : pFree.toFixed(2); //平費用
      gFree = isNull(gFree) ? "-" : gFree.toFixed(2); //谷費用
      jFree = isNull(jFree) ? "-" : jFree.toFixed(2); //尖費用
      eleUser = isNull(eleUser) ? "-" : eleUser.toFixed(2); //用量
      eleFree = isNull(eleFree) ? "-" : eleFree.toFixed(2); //費用
      resData[k].fValue = fConsumption;
      resData[k].pValue = pConsumption;
      resData[k].gValue = gConsumption;
      resData[k].jValue = jConsumption;
      resData[k].fValue1 = fFree;
      resData[k].pValue1 = pFree;
      resData[k].gValue1 = gFree;
      resData[k].jValue1 = jFree;
      resData[k].userValue = eleUser;
      resData[k].eleValue = eleFree;
    }
  }
};
/**
 * //拿取匹配的时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getMatchTime1 = function(fromDate, toDate, dateType) {
  let vm = this;
  let timeData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = new Date(
    dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  //三天内
  if (dateType == "0") {
    sDate = new Date(
      dateTool.format(new Date(fromDate), "yyyy-MM-dd hh:mm:ss")
    );
    for (let i = 0; i <= differ; i += 3600 * 1000) {
      let differDate = new Date(sDate.getTime() + i);
      timeData.push({
        time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh时"),
        value: "",
      });
    }
  } else if (dateType == "1") {
    sDate = new Date(
      dateTool.format(new Date(fromDate), "yyyy-MM-dd hh:mm:ss")
    );
    for (let i = 0; i <= differ; i += 3600 * 1000) {
      let differDate = new Date(new Date(sDate).getTime() + i);
      timeData.push({
        time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh:mm:ss"),
        value: null,
      });
    }
  }

  return timeData;
};
/**
 * //根据接口返回的time识别，转换 bdata要转换的数据，resData接口数据
 * @param {*} bardata 数据源
 * @param {*} resData 接口数据
 * @param {*} type 转换类型，判断是拿取用电量还是电费
 */
export const timeChabge1 = function(bardata, resData, type) {
  let bdata = JSON.parse(JSON.stringify(bardata)); //深拷贝防止被污染
  // console.log(bdata,'bdata')
  if (type == "f") {
    for (let i = 0; i < bdata.length; i++) {
      //峰
      //拿取峰平谷柱状图数据
      if (resData.length > 0) {
        for (let j = 0; j < resData.length; j++) {
          // console.log(resData[j].time, bdata[i].time, '峰')
          if (resData[j].time == bdata[i].time) {
            bdata[i].value = resData[j].fValue;
          }
        }
      }
    }
  } else if (type == "p") {
    for (let i = 0; i < bdata.length; i++) {
      //平
      //拿取峰平谷柱状图数据
      if (resData.length > 0) {
        for (let j = 0; j < resData.length; j++) {
          if (resData[j].time == bdata[i].time) {
            bdata[i].value = resData[j].pValue;
          }
        }
      }
    }
  } else if (type == "g") {
    for (let i = 0; i < bdata.length; i++) {
      //谷
      //拿取峰平谷柱状图数据
      if (resData.length > 0) {
        for (let j = 0; j < resData.length; j++) {
          if (resData[j].time == bdata[i].time) {
            bdata[i].value = resData[j].gValue;
          }
        }
      }
    }
  } else if (type == "j") {
    for (let i = 0; i < bdata.length; i++) {
      //谷
      //拿取峰平谷柱状图数据
      if (resData.length > 0) {
        for (let j = 0; j < resData.length; j++) {
          if (resData[j].time == bdata[i].time) {
            bdata[i].value = resData[j].jValue;
          }
        }
      }
    }
  } else {
    for (let i = 0; i < bdata.length; i++) {
      //用电量
      //拿取峰平谷柱状图数据
      if (resData.length > 0) {
        for (let j = 0; j < resData.length; j++) {
          if (resData[j].time == bdata[i].time) {
            bdata[i].value = resData[j].userValue;
          }
        }
      }
    }
  }
  return bdata;
};
/**
 * //拿取匹配的时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getMatchTime = function(fromDate, toDate, dateType, ishour) {
  let vm = this;
  let timeData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = new Date(
    dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  // console.log(differ,sDate,'sDate')
  if (differ / (24 * 3600 * 1000) <= 3) {
    if (ishour == true) {
      //三天内
      timeData = [];
      sDate = new Date(
        dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
      );
      for (let i = 0; i <= differ; i += 3600 * 1000) {
        let differDate = new Date(sDate.getTime() + i);
        timeData.push({
          time: dateTool.format(differDate, "yyyy-MM-dd hh"),
          value: "-",
        });
      }
    } else {
      //三天内
      timeData = [];
      sDate = new Date(
        dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
      );
      for (let i = 0; i <= differ; i += 3600 * 1000) {
        let differDate = new Date(sDate.getTime() + i);
        timeData.push({
          time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh:mm:ss"),
          value: "-",
        });
      }
    }
  } else {
    timeData = [];
    if (dateType == "year") {
      for (let k = 0; k < 12; k++) {
        let thisDate = new Date(fromDate);
        thisDate.setMonth(k);
        let time = new Date(thisDate);
        timeData.push({
          time: dateTool.format(new Date(time), "yyyy-MM") + "/01 00:00:00",
          value: "-",
        });
      }
    } else {
      for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
        //大于三天  手动拼装time，最后与拿到的time值进行匹配
        let differDate = new Date(sDate.getTime() + i);
        timeData.push({
          time:
            dateTool.format(new Date(differDate), "yyyy-MM-dd ") + "00:00:00",
          value: "-",
        });
      }
    }
  }

  return timeData;
};
//匹配时间段 数据页面特有
/**
 * //拿取匹配的时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getMatchTimeData = function(fromDate, toDate) {
  let vm = this;
  let timeData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let xData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = new Date(
    dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  for (let i = 0; i <= differ; i += 3600 * 1000) {
    let differDate = new Date(sDate.getTime() + i);
    timeData.push({
      time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh:mm:ss"),
      value: "-",
    });
    xData.push({
      time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh:mm:ss"),
    });
  }
  return timeData;
};
//获取x轴
/**
 * //拿取匹配的时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getXdata = function(fromDate, toDate, dateType) {
  let vm = this;
  let xData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = new Date(
    dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  switch (dateType) {
    case "day":
      {
        for (let index = 0; index < 24; index++) {
          xData.push(index + "时");
        }
      }
      break;
    case "week":
      {
        for (let i = 0; i <= differ; i += 3600 * 1000) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push(dateTool.format(new Date(differDate), "MM月-dd日hh时"));
        }
      }
      break;
    case "month":
      {
        for (let i = 0; i <= differ; i += 3600 * 1000) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push(dateTool.format(new Date(differDate), "dd日hh时"));
        }
      }
      break;
    case "timeInterval":
      {
        for (let i = 0; i <= differ; i += 3600 * 1000) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push(dateTool.format(new Date(differDate), "MM月-dd日hh时"));
        }
      }
      break;
    default: {
      break;
    }
  }
  return xData;
};
/**
 * //获取时间数组
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getTimeData = function(fromDate, toDate, dateType) {
  let vm = this;
  let xData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = new Date(
    dateTool.format(new Date(fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  switch (dateType) {
    case "0":
      {
        for (let index = 0; index < 24; index++) {
          xData.push({
            name: index + "时",
            id: index,
          });
        }
      }
      break;
    case "week":
      {
        for (let i = 0; i <= differ; i += 3600 * 1000) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push({
            name: dateTool.format(new Date(differDate), "MM月-dd日hh时"),
            id: i,
          });
        }
      }
      break;
    case "2":
      {
        for (let i = 0; i < differ; i += 3600 * 1000 * 24) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push({
            name: dateTool.format(new Date(differDate), "dd日"),
            id: xData.length,
          });
        }
      }
      break;
    case "5":
      {
        for (let k = 0; k < 12; k++) {
          let thisDate = new Date(fromDate);
          thisDate.setMonth(k);
          let time = new Date(thisDate);
          xData.push({
            name: dateTool.format(new Date(time), "MM月"),
            id: k,
          });
        }
      }
      break;
    default: {
      break;
    }
  }
  return xData;
};
/**
 * //拿取s上一时间段  比如传月查日，传年查月
 * @param {*} dateType 时间类型
 */
export const getNextTime = function(dateType) {
  let vm = this;
  let timeData = [];
  vm.fromDate = "";
  vm.toDate = "";
  if (dateType == "month") {
    vm.fromDate = dateTool.format(new Date(), "yyyy-MM-dd 00:00:00");
    vm.toDate =
      dateTool.format(
        new Date(new Date(vm.fromDate).getTime() + 24 * 60 * 60 * 1000),
        "yyyy-MM-dd"
      ) + " 00:00:00";
  } else {
    vm.fromDate =
      dateTool.format(
        //当前月
        new Date(),
        "yyyy-MM"
      ) + "/01 00:00:00";
    let date = new Date(vm.fromDate);
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let end = new Date(nextMonthFirstDay - oneDay);
    let item = new Date(vm.fromDate).setMonth(
      new Date(vm.fromDate).getMonth() + 1
    );
    vm.toDate = dateTool.format(new Date(item), "yyyy-MM") + "/01 00:00:00";
  }
  let differ1 = new Date(vm.toDate).getTime() - new Date(vm.fromDate).getTime();
  let sDate1 = new Date(
    dateTool.format(new Date(vm.fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  timeData[0] = vm.fromDate;
  timeData[1] = vm.toDate;
  return timeData;
};
/**
 * //拿取匹配当前时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export const getCurrentMatchTime = function(fromDate, toDate, dateType) {
  let vm = this;
  let timeData = [];
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  vm.fromDate = "";
  vm.toDate = "";
  if (typeof fromDate == "string") {
    let newStart = fromDate;
    fromDate = newStart;
  }
  if (typeof toDate == "string") {
    let newEnd = toDate;
    toDate = newEnd;
  }
  if (dateType == "month") {
    vm.fromDate = dateTool.format(new Date(), "yyyy-MM-dd 00:00:00");
    vm.fromDate = dateTool.format(new Date(), "yyyy-MM-dd 00:00:00");
    vm.toDate =
      dateTool.format(
        new Date(new Date(vm.fromDate).getTime() + 24 * 60 * 60 * 1000),
        "yyyy-MM-dd"
      ) + " 00:00:00";
  } else {
    vm.fromDate =
      dateTool.format(
        //当前月
        new Date(),
        "yyyy-MM"
      ) + "/01 00:00:00";
    dateTool.format(
      //当前月
      new Date(),
      "yyyy-MM"
    ) + "-01 00:00:00";
    let date = new Date(vm.fromDate);
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let end = new Date(nextMonthFirstDay - oneDay);
    let item = new Date(vm.fromDate).setMonth(
      new Date(vm.fromDate).getMonth() + 1
    );
    vm.toDate = dateTool.format(new Date(item), "yyyy-MM") + "/01 00:00:00";
  }
  let differ1 = new Date(vm.toDate).getTime() - new Date(vm.fromDate).getTime();
  let sDate1 = new Date(
    dateTool.format(new Date(vm.fromDate), "yyyy-MM-dd" + " 00:00:00")
  );
  if (differ1 / (24 * 3600 * 1000) <= 3) {
    //三天内
    timeData = [];
    sDate1 = new Date(
      dateTool.format(new Date(vm.fromDate), "yyyy-MM-dd" + " 00:00:00")
    );
    for (let i = 0; i <= differ1; i += 3600 * 1000) {
      let differDate = new Date(sDate1.getTime() + i);
      timeData.push({
        time: dateTool.format(new Date(differDate), "yyyy-MM-dd hh:mm:ss"),
        value: "",
      });
    }
  } else {
    timeData = [];
    for (let i = 0; i <= differ1; i += 3600 * 1000 * 24) {
      //大于三天  手动拼装time，最后与拿到的time值进行匹配
      let differDate = new Date(sDate1.getTime() + i);
      timeData.push({
        time: dateTool.format(new Date(differDate), "yyyy-MM-dd ") + "00:00:00",
        value: "",
      });
    }
  }
  return timeData;
};
